import React from 'react';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import VALoanCalculator from './VALoanCalculator.js';
import json from './vablock.js';

var VALoanCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$homeprice = attrs.homeprice,
      homeprice = _attrs$homeprice === void 0 ? 300000 : _attrs$homeprice,
      _attrs$loanProgram = attrs.loanProgram,
      loanProgram = _attrs$loanProgram === void 0 ? LOAN_PROGRAMS.fixed30Year : _attrs$loanProgram,
      _attrs$interestRate = attrs.interestRate,
      interestRate = _attrs$interestRate === void 0 ? 4.176 : _attrs$interestRate,
      _attrs$downPayment = attrs.downPayment,
      downPayment = _attrs$downPayment === void 0 ? 60000 : _attrs$downPayment,
      _attrs$downPaymentPer = attrs.downPaymentPercent,
      downPaymentPercent = _attrs$downPaymentPer === void 0 ? 20 : _attrs$downPaymentPer,
      _attrs$homeInsurance = attrs.homeInsurance,
      homeInsurance = _attrs$homeInsurance === void 0 ? Math.round(300000 * 0.00035 * 12) : _attrs$homeInsurance,
      _attrs$hoa = attrs.hoa,
      hoa = _attrs$hoa === void 0 ? 0 : _attrs$hoa,
      _attrs$taxRatePercent = attrs.taxRatePercent,
      taxRatePercent = _attrs$taxRatePercent === void 0 ? 1.2 : _attrs$taxRatePercent,
      _attrs$taxRate = attrs.taxRate,
      taxRate = _attrs$taxRate === void 0 ? 3600 : _attrs$taxRate,
      _attrs$includeTaxesIn = attrs.includeTaxesInsurance,
      includeTaxesInsurance = _attrs$includeTaxesIn === void 0 ? true : _attrs$includeTaxesIn;
    var defaultValues = {
      homeprice: homeprice,
      loanProgram: loanProgram,
      interestRate: interestRate,
      downPayment: downPayment,
      downPaymentPercent: downPaymentPercent,
      homeInsurance: homeInsurance,
      hoa: hoa,
      taxRate: taxRate,
      taxRatePercent: taxRatePercent,
      includeTaxesInsurance: includeTaxesInsurance
    };
    return /*#__PURE__*/React.createElement(VALoanCalculator, {
      defaultValues: defaultValues
    });
  },
  metadata: json
};
var VALoanCalculatorBlock$1 = VALoanCalculatorBlock;

export { VALoanCalculatorBlock$1 as default };
